import { get, post } from '../utils/api';

export const sourceClick = async (source) => await post('source/click', { source });

export const getAdsStatistic = async () => await get('source');